<div class="auto-group-source-item-container">
  <div class="source-selection">
    <div class="source-type">
      <div *ngIf="showBrandedSignUp" class="source-operator-content" [ngClass]="{'branded-signup': showBrandedSignUp}">
        <div class="single-operator">{{'new_group_settings.auto_group_sources.sources.branded_signup.value' | translate}}</div>
      </div>
      <auto-group-filter-box *ngIf="!showBrandedSignUp"
                             [options]="availableAutoGroupSourceList"
                             placeholder="{{'new_group_settings.dropdown_placeholder' | translate}}"
                             [(model)]="sourceItem.type"
                             name="influencer_group_type_{{itemIndex}}"
                             (selectEvent)="selectSourceType($event)">
      </auto-group-filter-box>
    </div>
    <div class="source-operator">
      <div *ngIf="hasSelectedSource" class="source-operator-content" [ngClass]="{'branded-signup': showBrandedSignUp}">
        <div class="single-operator">{{staticComparison}}</div>
      </div>
    </div>
    <div class="source-value">
      <auto-group-filter-box *ngIf="showValueDropdownList"
              [options]="sourceValueList"
              [(model)]="autoGroupSourceValue"
              name="auto_group_dropdown_value_{{sourceItem.type}}"
              placeholder="{{valueDropdownPlaceholder}}"
              [multiple]="isMultipleSelect"
              (selectEvent)="selectValue($event)"
              (closeDropDownEvent)="closeDropDown($event)">
      </auto-group-filter-box>
      <div *ngIf="showStaticValue" class="source-operator-content"
           [ngClass]="{
              'branded-signup': showBrandedSignUp,
              'error-border': noAvailabelCampaign
            }">
        <div class="single-operator">{{sourceStaticValue}}</div>
      </div>
      <achoo-text-field *ngIf="showInstagramFollower"
              placeholder="{{'new_group_settings.auto_group_sources.instagram_follower_placeholder' | translate}}"
              [(model)]="instagramFollwerValue"
              (keyup)="instagramFollowerInputKeyDown($event)"
              (focusOutEvent)="onFocusOutMentionInput()"
              name="auto_group_instagram_follower_{{sourceItem.type}}"
              [showError]="false">
      </achoo-text-field>
      <project-selection *ngIf="showProjectList" [options]="listProject"
                         name="auto_group_project_{{sourceItem.type}}"
                         [(model)]="selectedProject"
                         placeholder="{{'new_group_settings.dropdown_placeholder' | translate}}"
                         (selectEvent)="selectValue($event)"
                         (closeDropDownEvent)="closeDropDown($event)"
                         (afterDeleteProjectEvent)="afterDeleteProject($event)"
                         (editProjectEvent)="onEditOrCreateProject($event)">
      </project-selection>
    </div>
    <div class="source-editting"></div>
  </div>
  <div class="source-action">
    <div class="button-icon icon-delete" *ngIf="!showBrandedSignUp">
      <a class="icon-delete" (click)="deleteGroupSource()"></a>
    </div>
    <span class="error-msg" *ngIf="errorMessage && !showBrandedSignUp">{{errorMessage}}</span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-sources/auto-group-source-item/auto-group-source-item.component.html